module.exports = __webpack_public_path__ + "img/av155.2862b864.png";